module.exports = __webpack_public_path__ + "static/15-df53bcc45c36b66b0cb0aae349d1da64.jpg";